import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function AdminTimes() {
  const [times, setTimes] = useState([]);
  const [campeonatos, setCampeonatos] = useState([]);
  const [campSel, setCampSel] = useState('');
  const [form, setForm] = useState({ nome: '' });
  const [escudo, setEscudo] = useState(null);
  const [editando, setEditando] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => { api.get('/campeonatos').then(setCampeonatos).catch(() => {}); }, []);

  useEffect(() => {
    if (!campSel) { setTimes([]); return; }
    api.get(`/times/campeonato/${campSel}`).then(setTimes).catch(() => {});
  }, [campSel]);

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      const fd = new FormData();
      fd.append('campeonato_id', campSel);
      fd.append('nome', form.nome);
      if (escudo) fd.append('escudo', escudo);
      if (editando) { await api.uploadPut(`/times/${editando.id}`, fd); }
      else { await api.upload('/times', fd); }
      setMsg('Salvo!'); setForm({ nome: '' }); setEscudo(null); setEditando(null);
      api.get(`/times/campeonato/${campSel}`).then(setTimes);
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover?')) return;
    await api.delete(`/times/${id}`);
    api.get(`/times/campeonato/${campSel}`).then(setTimes);
  }

  return (
    <div>
      <h2 className="admin-title">Times</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <div className="form-group">
        <label>Campeonato</label>
        <select value={campSel} onChange={e => setCampSel(e.target.value)}>
          <option value="">Selecione</option>
          {campeonatos.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>
      {campSel && (
        <form onSubmit={salvar} className="admin-form">
          <h3>{editando ? 'Editar Time' : 'Novo Time'}</h3>
          <div className="form-row">
            <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ nome: e.target.value })} required /></div>
            <div className="form-group"><label>Escudo (opcional)</label><input type="file" accept="image/*" onChange={e => setEscudo(e.target.files[0])} /></div>
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-primary">Salvar</button>
            {editando && <button type="button" className="btn btn-secondary" onClick={() => { setEditando(null); setForm({ nome: '' }); }}>Cancelar</button>}
          </div>
        </form>
      )}
      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Escudo</th><th>Nome</th><th>Ações</th></tr></thead>
          <tbody>
            {times.map(t => (
              <tr key={t.id}>
                <td>{t.escudo ? <img src={`https://api.damelsoft.com.br/uploads/fotos/${t.escudo}`} alt="" style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 4 }} /> : '—'}</td>
                <td>{t.nome}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => { setEditando(t); setForm({ nome: t.nome }); }}>Editar</button>
                    <button className="btn btn-danger" onClick={() => deletar(t.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
